import React from 'react';
import EmptyState from '../components/EmptyState';

const DevIdentityAccessPage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
          Users & Identity
        </h1>
        <p className="text-sm text-slate-500">
          User management, sessions, and authentication events
        </p>
      </header>
      <EmptyState message="Users & Identity page - Coming soon" />
    </div>
  );
};

export default DevIdentityAccessPage;
